/* eslint-disable import/prefer-default-export */

// Allow
// - negative numbers
// 9 digits at most
// 2 decimal places at most
export const COST_REGEX = /^\d{0,9}(\.\d{0,2})?$/;

export function handleOnKeyPressCost(event: any) {
  const currentValue = event.target.value;
  const cursorPosition = event.target.selectionStart;

  // Check if all text is selected
  const isAllSelected = event.target.selectionStart === 0 && event.target.selectionEnd === currentValue.length;

  // Create the new value based on whether all text is selected or not
  const newValue = isAllSelected
    ? event.key // If all text is selected, the new value will just be the key pressed
    : currentValue.slice(0, cursorPosition) + event.key + currentValue.slice(cursorPosition);

  // Prevent the input if it doesn't match the regex
  if (!COST_REGEX.test(newValue)) {
    event.preventDefault();
  }
}

const hasPerAsPrefix = (input: string) => (input ? input.toLowerCase().startsWith("per") : false);

export function renderAmountPerQuantity(item: {
  currency_origin: string;
  amount_per_unit?: number;
  measurement_unit_display: string;
}) {
  if (!item) return null;
  const itemHasPerAsPrefix = hasPerAsPrefix(item.measurement_unit_display);
  return (
    <>
      {item.amount_per_unit} {item.currency_origin}
      {itemHasPerAsPrefix ? " " : " per "}
      {itemHasPerAsPrefix ? item.measurement_unit_display.toLocaleLowerCase() : item.measurement_unit_display}
    </>
  );
}

export function getChargeTitleFromValue(title: string) {
  if (title === "main_freight") return "Freight";
  if (title === "destination") return "Destination Charges";
  if (title === "origin") return "Origin Charges";
  if (title === "other") return "Other Charges";
  return "";
}
